import { i18n } from "@lingui/core";

/**
 * Minimal i18n setup. Phase-1 ships with hard-coded strings to keep boot
 * cheap; @lingui/macro extraction will be wired in Sprint 1 polish so all
 * <Trans> sites resolve via the catalogue.
 */

import { messages as enMessages } from "../i18n/en";
import { messages as esMessages } from "../i18n/es";

const CATALOGS = { es: esMessages, en: enMessages } as const;

export function setLocale(locale: "es" | "en"): void {
  const messages = CATALOGS[locale];
  i18n.load(locale, messages);
  i18n.activate(locale);
  document.documentElement.setAttribute("lang", locale);
}

export function detectLocale(): "es" | "en" {
  try {
    const raw = localStorage.getItem("docustudio-ui");
    if (raw) {
      const parsed = JSON.parse(raw) as { state?: { locale?: "es" | "en" } };
      const stored = parsed.state?.locale;
      if (stored === "es" || stored === "en") return stored;
    }
  } catch {
    /* ignore */
  }
  const nav = navigator.language?.split("-")[0];
  return nav === "en" ? "en" : "es";
}

export { i18n };
